<script setup lang="ts">
import { useSwRegistration } from '@/composables/useSwRegistration.js'

const {
  offlineReady,
  needRefresh,
  updateServiceWorker,
} = useSwRegistration()
</script>

<template>
  <q-banner
    v-if="offlineReady || needRefresh"
    class="pwa-toast bg-warning"
    role="alert"
  >
    <div class="message q-my-md">
      <span v-if="offlineReady">
        Du kannst die App jetzt nutzen. Viel Spaß! :-)
      </span>
      <span v-else>
        Ein Update ist verfügbar. Bitte neu laden.
      </span>
    </div>
    <q-btn v-if="needRefresh" label="Update" @click="updateServiceWorker()" />
  </q-banner>
</template>
